<div class="d-flex justify-content-center gap-2 otp-wrapper">
  @for (digit of digitValues; track i; let i = $index) {
    <input
      #otpInput
      type="text"
      maxlength="1"
      inputmode="numeric"
      pattern="[0-9]*"
      class="form-control otp-input"
      [class.is-invalid]="isInvalid(i)"
      [disabled]="disabled()"
      (input)="onDigitInput($event, i)"
      (keydown)="onKeyDown($event, i)"
      (focus)="onFocus(i)"
      (blur)="onBlur(i)"
      [value]="digitValues[i]"
      autocomplete="off"
      spellcheck="false"
      (paste)="onPaste($event)"
    />
  }
</div>
